import { Component, OnInit, signal } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { APIService } from 'app/shared/api.service';

@Component({
  selector: 'app-issue-tracking-home',
  standalone: false,

  templateUrl: './issue-tracking-home.component.html',
  styleUrl: './issue-tracking-home.component.css'
})
export class IssueTrackingHomeComponent implements OnInit {
  isAdmin = signal<boolean>(false);
  tabIndex = signal<number>(0);
  isUserAdmin = signal<boolean>(false);
  isStaff = signal<boolean>(false);
  can = { create: false };

  constructor(private apiService: APIService, private router: Router, private activatedRoute: ActivatedRoute) {
    this.isAdmin.set(apiService.isAdmin() || this.apiService.hasOrgRole('issuetracking_admin'));
    this.isStaff.set(apiService.isAdmin());
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // Handle route change here
        console.log('Route changed:', event.url);
        if (event.url.includes('admin')) {
          this.tabIndex.set(9);
        } else if (event.url.includes('create')) {
          this.tabIndex.set(1);
        } else {
          this.tabIndex.set(0);
        }
      }
    });
  }

  ngOnInit(): void {
    this.can.create = (this.apiService.getUserOrg().id === 4 || this.apiService.isAdmin());
  }

  navigate() {
    switch (this.tabIndex()) {
      case 9:
        if (this.isAdmin()) {
          this.router.navigate(['admin'], { relativeTo: this.activatedRoute });
        }
        break;
      case 1:
        this.router.navigate(['create'], { relativeTo: this.activatedRoute });
        break;
      default:
        this.router.navigate(['/issuetracking']);
        break;
    }
  }

  tabClick(tabIndex: number) {
    this.tabIndex.set(tabIndex);
    this.navigate();
  }
}
